import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CardProvider } from '@egovsolutions/angular-payment-types';

@Component({
    selector: 'app-card-logo',
    templateUrl: './card-logo.component.html',
    styleUrls: ['./card-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLogoComponent implements OnInit
{

    // Instances counter
    //
    // Necessary to avoid SVG url reference collisions.

    protected static createdInstances = 0;


    constructor
    (
        // Dependencies

        private readonly sanitizer: DomSanitizer
    )
    {}


    // Customization

    private _width?: string;
    protected get width(): string | number | undefined { return this._width; }
    @Input() protected set width(width: string | number | undefined)
    {
        this._width = typeof width === 'number' ? width + 'px' : width;
    }

    private _height?: string;
    protected get height(): string | number | undefined { return this._height; }
    @Input() protected set height(height: string | number | undefined)
    {
        this._height = typeof height === 'number' ? height + 'px' : height;
    }

    @Input() protected card: CardProvider = CardProvider.Other;
    @Input() protected color?: string;


    // SVG url reference collision prevention

    protected id!: number;
    protected get url(): string { return location.href; }


    // Initialization

    public ngOnInit()
    {
        this.id = CardLogoComponent.createdInstances++;
    }


    // Metrics

    protected get cardWidth(): SafeStyle
    {
        return this.sanitizer.bypassSecurityTrustStyle(this.width ? `calc(${this.width})` : 'auto');
    }
    protected get cardHeight(): SafeStyle
    {
        return this.sanitizer.bypassSecurityTrustStyle(this.height ? `calc(${this.height})` : 'auto');
    }

    protected get otherCardFontSize(): SafeStyle
    {
        if (this.height)
            return this.sanitizer.bypassSecurityTrustStyle(`calc((${this.height}) * 1.48)`);
        else if (this.width)
            return this.sanitizer.bypassSecurityTrustStyle(`calc((${this.width}) / 26 * 35)`);
        else
            return '';
    }
}
